import * as React from 'react';

import { useTiptapEditor } from '../../hooks/use-tiptap-editor';
import { useCommentAuthor } from '../../../../ui/tiptap/extensions/comment-mark';
import { Icon } from '../../../../ui/icon/icon';
import { Button } from '@cotera/client/v0/components/ui/button';

/**
 * Floating-toolbar button that opens the comment input for the current text selection.
 * Renders nothing when comments are disabled (no author) or the editor is read-only.
 */
export function CommentButton() {
  const { editor } = useTiptapEditor();
  const author = useCommentAuthor();

  const handleClick = React.useCallback(() => {
    if (editor === null) {
      return;
    }
    // Keep the current selection (the comment target) and reveal the input popover.
    editor.chain().focus().commentInputShow().run();
  }, [editor]);

  if (editor === null || author === null || !editor.isEditable) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      role="button"
      tabIndex={-1}
      title="Comment"
      aria-label="Comment"
      onClick={handleClick}
    >
      {/* The same glyph the header's comments control carries: one mark for the
          feature, wherever you meet it. */}
      <Icon icon="message-square-more" className="tiptap-button-icon" />
    </Button>
  );
}
